import React from 'react';

import {Skeleton} from 'coreComponents';
import {useCmsContent} from 'coreHooks';

import Content from 'brand/app/contentful/components/Content';

import {IProductContentAssetsProps} from './IProductContentAsset';

import styles from './ProductContentAsset.module.scss';

const ProductContentAsset = (id:IProductContentAssetsProps) => {
	const {data: content} = useCmsContent({
		contentType: 'contentCard',
		config: {
			variables: {
				internalTitle: id.id,
			},
		},
		collectionKey: 'contentCardCollection',
	});

	if (!content) {
		return <Skeleton height="40px" /> as unknown as React.ReactElement;
	}

	return (
		<div className={styles['product-detail__content-asset-card']}>
			<Content data={content}/>
		</div>
	);
};

export default ProductContentAsset;
